/**
 * Display names as "First Last" (UI, mail, ZIP manifest). Sorting, Stundenzettel
 * cells D7/L7, and folder names `LastName-FirstName` stay last-name-first.
 */

export function formatPersonName(person: {
  firstName?: string | null;
  lastName?: string | null;
}): string {
  return [person.firstName, person.lastName]
    .map((part) => (part ?? "").trim())
    .filter((part) => part.length > 0)
    .join(" ");
}
